import { useEffect, useState } from 'react';

interface Props {
  value: number; // 0..1
  onChange: (n: number) => void;
  step?: number;
  autoFocus?: boolean;
  decimals?: number;
}

export function PctInput({ value, onChange, step = 0.0025, autoFocus, decimals = 2 }: Props) {
  const [text, setText] = useState(fmt(value, decimals));
  useEffect(() => {
    const parsed = Number(text);
    if (!isFinite(parsed) || parsed / 100 !== value) setText(fmt(value, decimals));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <div className="relative">
      <input
        type="number"
        inputMode="decimal"
        step={step * 100}
        className="input pr-8 text-right font-mono tabular-nums"
        value={text}
        autoFocus={autoFocus}
        onChange={e => {
          setText(e.target.value);
          const n = Number(e.target.value);
          if (isFinite(n)) onChange(n / 100);
        }}
        onBlur={() => setText(fmt(value, decimals))}
      />
      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-ink-400 dark:text-ink-300">%</span>
    </div>
  );
}

function fmt(v: number, decimals: number): string {
  return (v * 100).toFixed(decimals);
}
